import { Link } from "react-router-dom";
import { Star, ArrowRight, Sparkle, Clock4 } from "lucide-react";
import { TEAM_ASTROLOGERS, IMAGES } from "@/data/content";

export default function MegaMenu({ onNavigate }) {
  return (
    <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-5 p-5" data-testid="consultation-megamenu">
      <div className="space-y-3">
        {TEAM_ASTROLOGERS.map((a) => (
          <div key={a.name} className="flex items-center gap-4 bg-white/80 border border-[#F0DFC2] rounded-2xl p-4" data-testid="megamenu-astrologer">
            <span className="w-12 h-12 rounded-full grid place-items-center shrink-0 font-display text-lg font-bold text-white" style={{ background: "linear-gradient(135deg,#C68A2E,#8A4E17)" }}>
              PJ
            </span>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-maroon text-[15px] leading-tight">{a.name}</p>
              <p className="text-xs text-[#8A7364]">{a.tags}</p>
              <p className="text-xs text-[#B45309] mt-0.5">
                <Star size={10} className="inline mr-1" fill="currentColor" />
                {a.rating} <span className="text-[#8A7364]">({a.sessions})</span>
              </p>
            </div>
            <Link
              to={a.href}
              onClick={onNavigate}
              data-testid="astrologer-book-elite-astrologer-priya-ji"
              className="btn-gold px-6 py-2.5 rounded-full text-sm font-bold shrink-0"
            >
              Book Now
            </Link>
          </div>
        ))}

        <Link
          to="/trusted-astrologer"
          onClick={onNavigate}
          data-testid="megamenu-myastrosaathi-card"
          className="group flex items-center gap-3.5 rounded-2xl p-4 border border-[#E5B77E]/60 grain transition-transform duration-300 hover:-translate-y-0.5"
          style={{ background: "linear-gradient(135deg,#561418 0%,#400F13 100%)" }}
        >
          <span className="w-10 h-10 rounded-full bg-[#E5B77E]/15 border border-[#E5B77E]/50 grid place-items-center shrink-0">
            <Clock4 size={17} className="text-[#F5BC5C]" />
          </span>
          <span className="flex-1 min-w-0">
            <span className="flex items-center gap-2">
              <span className="relative flex h-2 w-2 shrink-0">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#7CFC9B] opacity-70" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#7CFC9B]" />
              </span>
              <span className="font-cinzel text-[11px] tracking-[0.2em] uppercase text-[#F5BC5C] font-semibold">MyAstroSaathi 24/7</span>
            </span>
            <span className="block text-sm font-semibold text-[#FDF3E3] mt-1 leading-tight">Consult with Premium Elite Astrologers</span>
          </span>
          <ArrowRight size={17} className="text-[#F5BC5C] shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>

        <div className="grid grid-cols-2 gap-3">
          <Link to="/the-call-consultation#card-couple" onClick={onNavigate} data-testid="megamenu-love-card" className="group rounded-2xl overflow-hidden border border-[#F0DFC2] bg-white/80">
            <div className="h-24 overflow-hidden">
              <img
                src="/love-marriage.webp"
                alt="Love and Marriage Consultation"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-3">
              <p className="text-sm font-semibold text-maroon">Love & Marriage Consultation</p>
              <p className="text-xs text-[#B45309] mt-0.5">
                <Star size={9} className="inline mr-0.5" fill="currentColor" />Compatibility · Union timing
              </p>
            </div>
          </Link>
          <Link to="/the-call-consultation#card-personal" onClick={onNavigate} data-testid="megamenu-wealth-card" className="group rounded-2xl overflow-hidden border border-[#F0DFC2] bg-white/80">
            <div className="h-24 overflow-hidden">
              <img src={IMAGES.gemGoldRing} alt="Wealth Consultation" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-3">
              <p className="text-sm font-semibold text-maroon">Wealth Consultation</p>
              <p className="text-xs text-[#B45309] mt-0.5">
                <Sparkle size={9} className="inline mr-0.5" fill="currentColor" />Dhan Yog · Money growth
              </p>
            </div>
          </Link>
        </div>
      </div>

      <div className="relative rounded-2xl overflow-hidden p-6 grain" style={{ background: "linear-gradient(150deg,#B26B26 0%,#8F5F2A 100%)" }}>
        <div className="flex items-center gap-4">
          <img src={IMAGES.sagePortrait} alt="Sachin Sharma" className="w-16 h-16 rounded-full object-cover border-2 border-[#F2B24C]" style={{ objectPosition: "70% 15%" }} />
          <div>
            <p className="font-display text-2xl font-semibold text-[#FDF3E3] leading-tight">Sachin Sharma Ji</p>
            <p className="text-[#FFE0AE] text-xs mt-0.5">The Messenger of Shiva</p>
          </div>
        </div>
        <p className="font-display text-xl font-semibold text-[#FDF3E3] mt-5">{`15+ Years of Sacred Practice`}</p>
        <p className="text-[#F7E8CF] text-[13px] mt-2 leading-relaxed">
          Private, confidential Vedic guidance — session conducted personally, chart explained in front of you.
        </p>
        <Link
          to="/the-call-consultation"
          onClick={onNavigate}
          data-testid="megamenu-start-consultation"
          className="btn-gold mt-5 w-full inline-flex items-center justify-center gap-2 font-bold py-3 rounded-full"
        >
          Start Consultation <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
